import {
	userForgetPasswordSuccess,
	userForgetPasswordError,
	userResetPasswordSuccess,
	userResetPasswordError,
} from './reducer';

import { postFakeForgetPwd } from '../../../helpers/fakebackend_helper';
import {
	postJwtForgetPwd,
	postJwtResetPwd,
} from '../../../helpers/auth/backend_helper';
import { constants } from '../../../config';

export const userForgetPassword = (user, history) => async dispatch => {
	try {
		const systemUrl = window.location.origin;
		let response;
		if (constants.REACT_APP_DEFAULTAUTH === 'jwt') {
			response = postJwtForgetPwd(user.email, systemUrl);
		} else {
			response = postFakeForgetPwd(user.email);
		}

		const data = await response;

		if (data) {
			dispatch(
				userForgetPasswordSuccess(
					'El enlace de restablecimiento se envió a su buzón, verifique allí primero'
				)
			);
			return { success: true };
		}
	} catch (forgetError) {
		dispatch(userForgetPasswordError(forgetError));
		return { success: false };
	}
};

export const userResetPassword = (data, history) => async dispatch => {
	try {
		let response;
		if (constants.REACT_APP_DEFAULTAUTH === 'jwt') {
			response = postJwtResetPwd(data);
		} else {
			response = postFakeResetPwd(data);
		}

		const result = await response;

		if (result) {
			dispatch(
				userResetPasswordSuccess(
					'La contraseña se restableció correctamente, por favor inicie sesión con su nueva contraseña'
				)
			);
		}
	} catch (resetError) {
		console.log(resetError);
		dispatch(
			userResetPasswordError(
				'Error al restablecer la contraseña, intente nuevamente'
			)
		);
	}
};
